/* Engelsebouten.nl — Maatzoeker
 * Velden perken elkaar in: elke keuze laat alleen nog maten over die in voorraad bestaan.
 * Tab of Enter neemt de gemarkeerde suggestie over en springt naar het volgende veld.
 * Pijltjes links/rechts wisselen de productgroep-tabbladen.
 */
(function () {
  'use strict';

  var GROUPS = [
    ['alles', 'Alles'],
    ['zeskantbouten', 'Zeskantbouten'],
    ['tapbouten', 'Tapbouten'],
    ['inbusbouten', 'Inbusbouten'],
    ['stelschroeven', 'Stelschroeven'],
    ['moeren', 'Moeren'],
    ['draadstangen', 'Draadstangen'],
    ['overig', 'Overig']
  ];

  /* [tag in Shopify, label in de zoeker, productgroep] — volgorde = sorteervolgorde */
  var SUBTYPES = [
    ['Zeskantbout deeldraad', 'Zeskantbout (deeldraad)', 'zeskantbouten'],
    ['Zeskantbout', 'Zeskantbout', 'zeskantbouten'],
    ['Tapbout voldraad', 'Tapbout (voldraad)', 'tapbouten'],
    ['Cilinderkop', 'Cilinderkop', 'inbusbouten'],
    ['Verzonken kop', 'Verzonken kop', 'inbusbouten'],
    ['Stelschroef binnenzeskant', 'Stelschroef', 'stelschroeven'],
    ['Zeskantmoer', 'Zeskantmoer', 'moeren'],
    ['Zware zeskantmoer (heavy hex)', 'Zware zeskantmoer (heavy hex)', 'moeren'],
    ['Zelfborgende moer (nyloc)', 'Borgmoer (nyloc)', 'moeren'],
    ['Kroonmoer', 'Kroonmoer', 'moeren'],
    ['Kroonmoer laag model', 'Kroonmoer laag model', 'moeren'],
    ['Trackschoemoer', 'Trackschoemoer (rupsband)', 'moeren'],
    ['Draadstang 1 meter', 'Draadstang', 'draadstangen'],
    ['Draadstang 3ft', 'Draadstang 3 ft', 'draadstangen'],
    ['Draadstang ASTM B7', 'Draadstang B7', 'draadstangen'],
    ['Draadstang messing', 'Draadstang messing', 'draadstangen'],
    ['Oogbout DIN 580', 'Oogbout', 'overig'],
    ['Oogmoer DIN 582', 'Oogmoer', 'overig'],
    ['Sluitring DIN 125B', 'Sluitring', 'overig'],
    ['Veerring DIN 127B', 'Veerring', 'overig'],
    ['Veerring DIN 7980', 'Veerring', 'overig'],
    ['Plug DIN 906 conisch', 'Plug conisch (DIN 906)', 'overig'],
    ['Plug DIN 910 met kraag', 'Plug met kraag (DIN 910)', 'overig'],
    ['Smeernippel', 'Smeernippel', 'overig'],
    ['Schuifnippel vlak', 'Schuifnippel', 'overig'],
    ['Assortimentsdoos smeernippels inch/UNF', 'Assortimentsdoos', 'overig']
  ];
  var TYPE_BY_PRODUCTTYPE = {
    'Zeskantbouten': 'zeskantbouten', 'Inbusbouten': 'inbusbouten', 'Stelschroeven': 'stelschroeven',
    'Moeren': 'moeren', 'Borgmiddelen': 'moeren', 'Draadstangen': 'draadstangen'
  };

  var FIELDS = [
    { k: 'type', label: 'Type', ph: 'bv. cilinderkop' },
    { k: 'draad', label: 'Draadsoort', ph: 'bv. UNC' },
    { k: 'dia', label: 'Diameter', ph: 'bv. 1/2"' },
    { k: 'spoed', label: 'Spoed (TPI)', ph: 'bv. 13' },
    { k: 'lengte', label: 'Lengte', ph: 'bv. 2"' },
    { k: 'uitv', label: 'Uitvoering', ph: 'bv. verzinkt' },
    { k: 'kwal', label: 'Kwaliteit', ph: 'bv. Grade 5' }
  ];

  var DRAAD_LABEL = { UNC: 'UNC', UNF: 'UNF', BSW: 'BSW (Whitworth)', BSF: 'BSF', BSP: 'Gasdraad (BSP)', M: 'Metrisch' };
  var DRAAD_SORT = { UNC: 1, UNF: 2, BSW: 3, BSF: 4, BSP: 5, M: 6 };
  var NR_SIZES = { '2': 0.086, '4': 0.112, '5': 0.125, '6': 0.138, '8': 0.164, '10': 0.19, '12': 0.216 };

  var EUR = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });

  /* ---------- helpers ---------- */
  function frac(s) {
    s = String(s || '').trim();
    var m = s.match(/^(\d+)\.(\d+)\/(\d+)$/);
    if (m) return +m[1] + m[2] / m[3];
    m = s.match(/^(\d+)\/(\d+)$/);
    if (m) return m[1] / m[2];
    m = s.match(/^(\d+(?:\.\d+)?)$/);
    if (m) return +m[1];
    return NaN;
  }
  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/["”″']/g, '')
      .replace(/\binch\b|\bin\b|\btpi\b|\bmm\b/g, '')
      .replace(/(\d)\s+(\d+\/\d+)/g, '$1.$2')
      .replace(/,/g, '.')
      .replace(/[\s()\-]+/g, '');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function val(key, label, sort) { return { key: key, label: label, sort: sort }; }

  /* Typefamilies: 'Zeskantbout' + 'Zeskantbout deeldraad' horen bij elkaar. Wie 'zeskantbout' typt,
     krijgt eerst 'Alle zeskantbouten' (alle soorten), daarna pas de losse soorten. */
  var FAM_PLURAL = { Zeskantbout: 'zeskantbouten', Kroonmoer: 'kroonmoeren', Draadstang: 'draadstangen', Veerring: 'veerringen', Plug: 'pluggen' };
  function famOf(key) { return String(key || '').split(' ')[0]; }
  function typeMatch(v, s) {
    if (!v) return false;
    if (String(s).indexOf('fam:') === 0) return famOf(v.key) === String(s).slice(4);
    return v.key === s;
  }

  /* ---------- per product afgeleide kenmerken ---------- */
  function deriveType(p) {
    var tags = p.tg || [];
    for (var i = 0; i < SUBTYPES.length; i++) {
      if (tags.indexOf(SUBTYPES[i][0]) !== -1) return { v: val(SUBTYPES[i][0], SUBTYPES[i][1], i), g: SUBTYPES[i][2] };
    }
    return { v: p.ty ? val(p.ty, p.ty, 99) : null, g: TYPE_BY_PRODUCTTYPE[p.ty] || 'overig' };
  }
  function deriveDraad(p) {
    var d = String(p.d || '').trim();
    if (!d) return null;
    var k;
    if (/gasdraad|bsp/i.test(d)) k = 'BSP';
    else if (/metrisch/i.test(d)) k = 'M';
    else if (/unf/i.test(d)) k = 'UNF';
    else k = d.toUpperCase();
    return val(k, DRAAD_LABEL[k] || k, DRAAD_SORT[k] || 9);
  }
  function deriveDia(p) {
    var d = String(p.di || '').trim().replace(/^UNF\s+/i, '');
    if (!d) return null;
    /* In UNC/UNF heet 3/16" met 24 of 32 gangen officieel Nr. 10 (BSW 3/16" blijft 3/16") */
    if (/^3\/16"?$/.test(d) && /^(UNC|UNF)$/i.test(String(p.d || '').trim()) && /^(24|32)$/.test(String(p.s || '').trim())) d = 'Nr. 10';
    var m = d.match(/^Nr\.?\s*(\d+)/i);
    if (m) return val('nr' + m[1], 'Nr. ' + m[1] + (m[1] === '10' ? ' (3/16")' : ''), NR_SIZES[m[1]] || 0.19);
    m = d.match(/^M\d+\s*\/\s*([\d.\/]+)"/i); /* 'M27 / 1"' -> 1" */
    if (m) d = m[1] + '"';
    m = d.match(/^R\s*([\d.\/]+)"?$/i);
    if (m) return val('R' + m[1], 'R' + m[1] + '"', 100 + frac(m[1]));
    m = d.match(/^M(\d+)$/i);
    if (m) return val('M' + m[1], 'M' + m[1], 200 + (+m[1]));
    m = d.match(/^([\d.\/]+)"?$/);
    if (m) {
      var f = frac(m[1]);
      if (!isNaN(f)) return val(m[1], m[1] + '"', f);
    }
    return val(d, d, 300);
  }
  function deriveSpoed(p) {
    var s = String(p.s || '').trim();
    if (!s) return null;
    var n = parseFloat(s.replace(',', '.'));
    return val(s, s + ' TPI', isNaN(n) ? 999 : n);
  }
  function deriveLengte(p) {
    var t = p.t || '';
    var m = t.match(/\bx\s*(\d+(?:\.\d+\/\d+|\/\d+)?)\s*"/i);
    if (m) {
      var inch = frac(m[1]);
      var mm = p.l ? Math.round(p.l) : Math.round(inch * 25.4);
      return val(m[1], m[1] + '" (' + mm + ' mm)', inch * 25.4);
    }
    m = t.match(/\bx\s*(\d+)\s*mm\b/i);
    if (m) return val(m[1] + 'mm', m[1] + ' mm', +m[1]);
    if (/\b3\s*ft\b/i.test(t)) return val('3ft', '3 ft (914 mm)', 914);
    if (/\b1\s*meter\b/i.test(t)) return val('1m', '1 meter', 1000);
    if (p.l) return val(p.l + 'mm', p.l + ' mm', +p.l);
    return null;
  }
  function deriveUitv(p) {
    var mat = String(p.m || ''), beh = String(p.b || '');
    if (/rvs\s*a4/i.test(mat)) return val('RVS A4', 'RVS A4', 4);
    if (/rvs/i.test(mat)) return val('RVS', 'RVS', 5);
    if (/messing/i.test(mat)) return val('Messing', 'Messing', 6);
    if (!beh) return null;
    var order = { Verzinkt: 1, Zwart: 2, Blank: 3 };
    return val(beh, beh, order[beh] || 7);
  }
  function deriveKwal(p) {
    var k = String(p.k || '').trim();
    if (!k) return null;
    var order = ['Grade 5', '8.8', 'Klasse 8', '10.9', '12.9', '45H', 'A4-70', 'Klasse 6', '4.6', 'C15', 'ASTM A193 B7', 'ASTM A194 2H'];
    var i = order.indexOf(k);
    return val(k, k, i === -1 ? 50 : i);
  }

  function prepare(items) {
    return items.map(function (p) {
      var t = deriveType(p);
      p.g = t.g;
      p.f = {
        type: t.v,
        draad: deriveDraad(p),
        dia: deriveDia(p),
        spoed: deriveSpoed(p),
        lengte: deriveLengte(p),
        uitv: deriveUitv(p),
        kwal: deriveKwal(p)
      };
      p.x = p.x === true || p.x === 'true';
      return p;
    });
  }

  /* ---------- data laden ---------- */
  var CACHE_KEY = 'eb-maatzoeker:v1';
  function loadData(endpoint) {
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.ts < 15 * 60 * 1000 && c.items && c.items.length) return Promise.resolve(c.items);
    } catch (e) { /* geen opslag beschikbaar */ }
    function page(n) {
      var sep = endpoint.indexOf('?') === -1 ? '?' : '&';
      return fetch(endpoint + sep + 'page=' + n, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (t) { return JSON.parse(t); });
    }
    return page(1).then(function (first) {
      var rest = [];
      for (var i = 2; i <= (first.pages || 1); i++) rest.push(page(i));
      return Promise.all(rest).then(function (pages) {
        var items = first.items.slice();
        pages.forEach(function (pg) { items = items.concat(pg.items); });
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), items: items })); } catch (e) { /* vol of geblokkeerd */ }
        return items;
      });
    });
  }

  /* ---------- component ---------- */
  function Maatzoeker(root) {
    this.root = root;
    this.endpoint = root.getAttribute('data-endpoint');
    this.limit = parseInt(root.getAttribute('data-limit') || '10', 10);
    this.contactUrl = root.getAttribute('data-contact') || '/pages/contact';
    this.phone = root.getAttribute('data-phone') || '';
    this.products = [];
    this.tab = root.getAttribute('data-tab') || 'alles';
    this.sel = {};
    this.showAll = false;
    this.ui = {};
    this.query = (root.getAttribute('data-query') || '').trim();
    this.build();
    this.readHash();
    var self = this, fromHash = Object.keys(this.sel).length > 0 || this.tab !== (root.getAttribute('data-tab') || 'alles');
    this.setLoading(true);
    loadData(this.endpoint).then(function (items) {
      self.products = prepare(items);
      self.setLoading(false);
      if (self.query && !fromHash) self.applyQuery(self.query);
      self.update();
    }).catch(function (err) {
      console.warn('[maatzoeker]', err);
      self.root.querySelector('.mz__status').innerHTML =
        'De maatzoeker kon niet laden. Gebruik de zoekfunctie of <a href="' + esc(self.contactUrl) + '">neem contact op</a>.';
    });
  }

  Maatzoeker.prototype.build = function () {
    var self = this, r = this.root;
    var tabs = r.querySelector('.mz__tabs');
    tabs.innerHTML = GROUPS.map(function (g, i) {
      return '<button type="button" role="tab" class="mz__tab" id="mz-tab-' + g[0] + '" data-g="' + g[0] + '" aria-selected="false" tabindex="-1">' +
        esc(g[1]) + ' <span class="mz__tabcount" aria-hidden="true"></span></button>';
    }).join('');
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('.mz__tab');
      if (b) self.setTab(b.getAttribute('data-g'), true);
    });
    tabs.addEventListener('keydown', function (e) {
      var keys = { ArrowRight: 1, ArrowLeft: -1, Home: 'home', End: 'end' };
      if (!(e.key in keys)) return;
      e.preventDefault();
      var btns = Array.prototype.slice.call(tabs.querySelectorAll('.mz__tab'));
      var i = btns.findIndex(function (b) { return b.getAttribute('data-g') === self.tab; });
      var d = keys[e.key];
      var n = d === 'home' ? 0 : d === 'end' ? btns.length - 1 : (i + d + btns.length) % btns.length;
      self.setTab(btns[n].getAttribute('data-g'), true);
    });

    var grid = r.querySelector('.mz__fields');
    grid.innerHTML = FIELDS.map(function (f) {
      var id = 'mz-' + f.k;
      return '<div class="mz__field" data-k="' + f.k + '">' +
        '<label class="mz__label" for="' + id + '">' + esc(f.label) + '</label>' +
        '<div class="mz__control">' +
        '<input id="' + id + '" class="mz__input" type="text" autocomplete="off" spellcheck="false" ' +
        'role="combobox" aria-autocomplete="list" aria-expanded="false" aria-controls="' + id + '-list" placeholder="' + esc(f.ph) + '">' +
        '<button type="button" class="mz__clear" tabindex="-1" aria-label="' + esc(f.label) + ' wissen">&times;</button>' +
        '<ul class="mz__list" id="' + id + '-list" role="listbox" hidden></ul>' +
        '</div></div>';
    }).join('');

    FIELDS.forEach(function (f) {
      var wrap = grid.querySelector('[data-k="' + f.k + '"]');
      var ui = {
        wrap: wrap,
        input: wrap.querySelector('.mz__input'),
        list: wrap.querySelector('.mz__list'),
        clear: wrap.querySelector('.mz__clear'),
        opts: [],
        shown: [],
        active: -1,
        typing: false
      };
      self.ui[f.k] = ui;
      ui.input.addEventListener('focus', function () { if (!ui.input.readOnly) { ui.input.select(); self.open(f.k); } });
      ui.input.addEventListener('blur', function () { setTimeout(function () { self.close(f.k, true); }, 120); });
      ui.input.addEventListener('input', function () {
        ui.typing = true;
        if (!ui.input.value.trim() && self.sel[f.k]) { delete self.sel[f.k]; self.update(f.k); }
        self.open(f.k);
      });
      ui.input.addEventListener('keydown', function (e) { self.onKey(f.k, e); });
      ui.list.addEventListener('mousedown', function (e) { e.preventDefault(); });
      /* markering volgt de muis, zodat Enter/Tab daarna ook de aangewezen keuze neemt */
      ui.list.addEventListener('mousemove', function (e) {
        var li = e.target.closest('.mz__opt');
        if (!li) return;
        var items = Array.prototype.slice.call(ui.list.querySelectorAll('.mz__opt'));
        var i = items.indexOf(li);
        if (i === -1 || i === ui.active) return;
        ui.active = i;
        items.forEach(function (x, j) { x.classList.toggle('is-active', j === i); });
        ui.input.setAttribute('aria-activedescendant', li.id || '');
      });
      ui.list.addEventListener('click', function (e) {
        if (e.target.closest('[data-q]')) { self.freeText(f.k); return; }
        var li = e.target.closest('[data-key]');
        if (!li) return;
        self.commit(f.k, li.getAttribute('data-key'));
        /* op een touchscreen niet doorspringen: dat zou steeds het toetsenbord openen */
        if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) ui.input.blur();
        else self.focusNext(f.k, 1);
      });
      ui.clear.addEventListener('click', function () {
        delete self.sel[f.k];
        ui.input.value = '';
        ui.typing = false;
        self.update();
        ui.input.focus();
      });
    });

    r.querySelector('.mz__reset').addEventListener('click', function () {
      self.sel = {};
      self.showAll = false;
      FIELDS.forEach(function (f) { self.ui[f.k].typing = false; });
      self.update();
      var first = self.firstFocusable();
      if (first) first.focus();
    });
    r.querySelector('.mz__results').addEventListener('click', function (e) {
      var more = e.target.closest('.mz__more');
      if (more) { self.showAll = true; self.renderResults(); return; }
      var add = e.target.closest('.mz__add');
      if (add) self.addToCart(add);
    });
    r.querySelector('.mz__results').addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.classList.contains('mz__qty')) {
        e.preventDefault();
        var btn = e.target.parentNode.querySelector('.mz__add');
        if (btn) self.addToCart(btn);
      }
    });
  };

  Maatzoeker.prototype.setLoading = function (on) {
    var self = this;
    this.root.classList.toggle('is-loading', on);
    FIELDS.forEach(function (f) { self.ui[f.k].input.disabled = on; });
    if (on) this.root.querySelector('.mz__status').textContent = 'Maten laden…';
  };

  /* ---------- filterlogica ---------- */
  Maatzoeker.prototype.inTab = function (p, tab) {
    tab = tab || this.tab;
    return tab === 'alles' || p.g === tab;
  };
  Maatzoeker.prototype.matches = function (p, except) {
    for (var k in this.sel) {
      if (k === except || this.sel[k] == null) continue;
      var v = p.f[k];
      if (k === 'type' ? !typeMatch(v, this.sel[k]) : (!v || v.key !== this.sel[k])) return false;
    }
    return true;
  };
  Maatzoeker.prototype.options = function (k) {
    var map = {}, self = this;
    this.products.forEach(function (p) {
      if (!self.inTab(p) || !self.matches(p, k)) return;
      var v = p.f[k];
      if (!v) return;
      if (!map[v.key]) map[v.key] = { key: v.key, label: v.label, sort: v.sort, n: 0 };
      map[v.key].n++;
    });
    if (k === 'type') {
      var fams = {};
      Object.keys(map).forEach(function (key) {
        var b = famOf(key);
        if (!fams[b]) fams[b] = { members: 0, n: 0, sort: Infinity };
        fams[b].members++;
        fams[b].n += map[key].n;
        fams[b].sort = Math.min(fams[b].sort, map[key].sort);
      });
      Object.keys(fams).forEach(function (b) {
        var fk = 'fam:' + b, f = fams[b];
        if (f.members < 2 && self.sel.type !== fk) return;
        var plural = FAM_PLURAL[b] || (b.toLowerCase() + 'en');
        map[fk] = { key: fk, label: plural.charAt(0).toUpperCase() + plural.slice(1), sort: f.sort - 0.5, n: f.n, fam: true, base: b, plural: plural };
      });
    }
    return Object.keys(map).map(function (key) { return map[key]; }).sort(function (a, b) {
      return a.sort - b.sort || String(a.label).localeCompare(String(b.label), 'nl');
    });
  };
  Maatzoeker.prototype.results = function () {
    var self = this;
    return this.products.filter(function (p) { return self.inTab(p) && self.matches(p); }).sort(function (a, b) {
      var fa = a.f, fb = b.f;
      return (fa.type ? fa.type.sort : 99) - (fb.type ? fb.type.sort : 99) ||
        (fa.draad ? fa.draad.sort : 9) - (fb.draad ? fb.draad.sort : 9) ||
        (fa.dia ? fa.dia.sort : 999) - (fb.dia ? fb.dia.sort : 999) ||
        (fa.lengte ? fa.lengte.sort : 0) - (fb.lengte ? fb.lengte.sort : 0) ||
        (fa.uitv ? fa.uitv.sort : 0) - (fb.uitv ? fb.uitv.sort : 0) ||
        a.t.localeCompare(b.t, 'nl');
    });
  };
  /* keuzes die in het huidige tabblad niet meer kunnen, vallen weg */
  /* Keuzes worden in veldvolgorde opnieuw toegevoegd; een keuze die (samen met de eerdere)
     niets meer oplevert in dit tabblad valt weg. Zo blijft bv. UNC + 1/2" staan als je van
     bouten naar moeren wisselt, en verdwijnt alleen de lengte. */
  Maatzoeker.prototype.prune = function () {
    var old = this.sel, self = this;
    this.sel = {};
    FIELDS.forEach(function (f) {
      if (old[f.k] == null) return;
      self.sel[f.k] = old[f.k];
      var any = self.products.some(function (p) { return self.inTab(p) && self.matches(p); });
      if (!any) delete self.sel[f.k];
    });
  };

  Maatzoeker.prototype.setTab = function (g, focus) {
    this.tab = g;
    this.showAll = false;
    if (this.sel.type) {
      var self = this;
      var still = this.products.some(function (p) { return self.inTab(p) && typeMatch(p.f.type, self.sel.type); });
      if (!still) delete this.sel.type;
    }
    this.prune();
    this.update();
    if (focus) {
      var b = this.root.querySelector('#mz-tab-' + g);
      if (b) b.focus();
    }
  };

  /* ---------- weergave ---------- */
  Maatzoeker.prototype.update = function (skip) {
    var self = this;
    if (!this.products.length) return;
    // tabbladen + aantallen (alle keuzes behalve type)
    var tabCounts = {};
    GROUPS.forEach(function (g) { tabCounts[g[0]] = 0; });
    this.products.forEach(function (p) {
      if (!self.matches(p, 'type')) return;
      tabCounts.alles++;
      tabCounts[p.g] = (tabCounts[p.g] || 0) + 1;
    });
    this.root.querySelectorAll('.mz__tab').forEach(function (b) {
      var g = b.getAttribute('data-g'), on = g === self.tab;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
      b.classList.toggle('is-empty', !tabCounts[g] && !on);
      b.querySelector('.mz__tabcount').textContent = tabCounts[g] || 0;
    });
    this.root.querySelector('.mz__fields').setAttribute('aria-labelledby', 'mz-tab-' + this.tab);

    var fixed = [];
    FIELDS.forEach(function (f) {
      var ui = self.ui[f.k];
      var opts = self.options(f.k);
      ui.opts = opts;
      var selected = self.sel[f.k] != null ? opts.filter(function (o) { return o.key === self.sel[f.k]; })[0] : null;
      var hide = !selected && (opts.length === 0 || (f.k === 'type' && opts.length <= 1));
      var auto = !selected && !hide && opts.length === 1;
      /* een veld met maar één mogelijke waarde is geen keuze: verbergen en onder de velden als 'hoort erbij' tonen */
      ui.wrap.hidden = hide || auto;
      if (auto) fixed.push('<b>' + esc(opts[0].label) + '</b>');
      ui.wrap.classList.toggle('is-auto', auto);
      ui.wrap.classList.toggle('is-set', !!selected);
      ui.input.readOnly = auto;
      ui.input.tabIndex = auto ? -1 : 0;
      ui.auto = auto ? opts[0] : null;
      if (f.k !== skip && document.activeElement !== ui.input) {
        ui.input.value = selected ? selected.label : auto ? opts[0].label : '';
        ui.typing = false;
      }
      ui.input.setAttribute('aria-label', f.label + (auto ? ' (staat vast: ' + opts[0].label + ')' : ''));
      if (!ui.list.hidden) self.renderList(f.k);
    });

    var fx = this.root.querySelector('.mz__fixed');
    if (!fx) {
      fx = document.createElement('p');
      fx.className = 'mz__fixed';
      this.root.querySelector('.mz__fields').insertAdjacentElement('afterend', fx);
    }
    var anySel = Object.keys(this.sel).some(function (k) { return self.sel[k] != null; });
    fx.hidden = !((anySel || this.tab !== 'alles') && fixed.length);
    fx.innerHTML = fixed.length ? 'Hoort automatisch bij uw keuze: ' + fixed.join(' · ') : '';

    this.renderResults();
    this.writeHash();
  };

  Maatzoeker.prototype.filtered = function (k) {
    var ui = this.ui[k];
    var q = ui.typing ? norm(ui.input.value) : '';
    if (!q) return ui.opts.slice();
    var exact = [], starts = [], contains = [];
    ui.opts.forEach(function (o) {
      var l = norm(o.label), key = norm(o.key);
      if (o.fam) {
        var nb = norm(o.base), np = norm(o.plural);
        if (nb === q || np === q || l === q) exact.push(o);
        else if (nb.indexOf(q) === 0 || np.indexOf(q) === 0) starts.push(o);
        else if (l.indexOf(q) !== -1) contains.push(o);
        return;
      }
      if (key === q || l === q) exact.push(o);                 /* '1' = 1", niet 1/4" */
      else if (l.indexOf(q) === 0 || key.indexOf(q) === 0) starts.push(o);
      else if (l.indexOf(q) !== -1) contains.push(o);
    });
    exact.sort(function (a, b) { return (b.fam ? 1 : 0) - (a.fam ? 1 : 0); });
    starts.sort(function (a, b) { return (b.fam ? 1 : 0) - (a.fam ? 1 : 0); });
    return exact.concat(starts, contains);
  };

  /* Meerdere woorden in één veld ('zeskantbout unc 1/2'): verdelen over de velden. */
  Maatzoeker.prototype.isFreeText = function (k) {
    var ui = this.ui[k];
    return ui.typing && !ui.shown.length && /\S\s+\S/.test(ui.input.value.trim());
  };
  Maatzoeker.prototype.freeText = function (k) {
    var ui = this.ui[k], q = ui.input.value.trim();
    var before = JSON.stringify(this.sel) + this.tab;
    ui.typing = false;
    this.close(k);
    this.showAll = false;
    this.applyQuery(q);
    if (JSON.stringify(this.sel) + this.tab === before) {
      /* niets herkend: tekst laten staan zodat de klant kan aanpassen */
      ui.input.value = q;
      ui.typing = true;
      this.open(k);
      return false;
    }
    this.update();
    var self = this, cur = ui.opts.filter(function (o) { return o.key === self.sel[k]; })[0];
    ui.input.value = cur ? cur.label : '';
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) { ui.input.blur(); return true; }
    var pos = FIELDS.map(function (f) { return f.k; }).indexOf(k), next = null;
    for (var i = pos + 1; i < FIELDS.length && !next; i++) {
      var u = this.ui[FIELDS[i].k];
      if (!u.wrap.hidden && !u.input.readOnly && this.sel[FIELDS[i].k] == null) next = u.input;
    }
    if (next) next.focus();
    else { var t = this.root.querySelector('.mz__qty, .mz__link'); if (t) t.focus(); else ui.input.blur(); }
    return true;
  };

  Maatzoeker.prototype.renderList = function (k) {
    var ui = this.ui[k], self = this;
    var shown = this.filtered(k);
    ui.shown = shown;
    if (ui.active >= shown.length) ui.active = shown.length - 1;
    if (ui.active < 0 && shown.length) ui.active = 0;
    if (!shown.length && this.isFreeText(k)) {
      ui.list.innerHTML = '<li role="option" id="mz-' + k + '-o0" data-q="1" class="mz__opt is-active" aria-selected="false">' +
        '<span>Zoek op <b>' + esc(ui.input.value.trim()) + '</b></span><span class="mz__n">Enter</span></li>';
      ui.input.setAttribute('aria-activedescendant', 'mz-' + k + '-o0');
      return;
    } else if (!shown.length) {
      ui.list.innerHTML = '<li class="mz__none" role="presentation">Geen maat die past bij uw andere keuzes</li>';
    } else {
      ui.list.innerHTML = shown.map(function (o, i) {
        var sel = self.sel[k] === o.key;
        return '<li role="option" id="mz-' + k + '-o' + i + '" data-key="' + esc(o.key) + '" class="mz__opt' +
          (i === ui.active ? ' is-active' : '') + (sel ? ' is-selected' : '') + '" aria-selected="' + (sel ? 'true' : 'false') + '">' +
          '<span>' + esc(o.label) + (o.fam ? ' <small class="mz__fam">alle soorten</small>' : '') + '</span><span class="mz__n">' + o.n + '</span></li>';
      }).join('');
    }
    ui.input.setAttribute('aria-activedescendant', ui.active >= 0 && shown.length ? 'mz-' + k + '-o' + ui.active : '');
    var act = ui.list.querySelector('.is-active');
    if (act && act.scrollIntoView) act.scrollIntoView({ block: 'nearest' });
  };

  Maatzoeker.prototype.open = function (k) {
    var ui = this.ui[k];
    if (ui.input.readOnly || ui.input.disabled) return;
    ui.active = 0;
    if (this.sel[k] != null && !ui.typing) {
      var idx = ui.opts.findIndex(function (o) { return o.key === this.sel[k]; }, this);
      ui.active = Math.max(0, idx);
    }
    ui.list.hidden = false;
    ui.input.setAttribute('aria-expanded', 'true');
    ui.wrap.classList.add('is-open');
    this.renderList(k);
  };
  Maatzoeker.prototype.close = function (k, restore) {
    var ui = this.ui[k];
    ui.list.hidden = true;
    ui.input.setAttribute('aria-expanded', 'false');
    ui.wrap.classList.remove('is-open');
    if (restore && document.activeElement !== ui.input) {
      var cur = ui.opts.filter(function (o) { return o.key === this.sel[k]; }, this)[0];
      ui.input.value = cur ? cur.label : ui.auto ? ui.auto.label : '';
      ui.typing = false;
    }
  };

  Maatzoeker.prototype.commit = function (k, key) {
    var ui = this.ui[k];
    this.sel[k] = key;
    this.showAll = false;
    ui.typing = false;
    var o = ui.opts.filter(function (x) { return x.key === key; })[0];
    ui.input.value = o ? o.label : key;
    this.close(k);
    this.update();
  };

  Maatzoeker.prototype.focusables = function () {
    var self = this;
    return FIELDS.map(function (f) { return self.ui[f.k]; })
      .filter(function (ui) { return !ui.wrap.hidden && !ui.input.readOnly; })
      .map(function (ui) { return ui.input; });
  };
  Maatzoeker.prototype.firstFocusable = function () { return this.focusables()[0]; };
  Maatzoeker.prototype.focusNext = function (k, dir) {
    var list = this.focusables();
    var cur = this.ui[k].input;
    var i = list.indexOf(cur);
    var next = null;
    if (i === -1) {
      // huidig veld is net vast komen te staan of verdwenen: zoek het eerstvolgende in DOM-volgorde
      var order = FIELDS.map(function (f) { return f.k; });
      var pos = order.indexOf(k);
      for (var j = pos + dir; j >= 0 && j < order.length; j += dir) {
        var ui = this.ui[order[j]];
        if (list.indexOf(ui.input) !== -1) { next = ui.input; break; }
      }
    } else {
      next = list[i + dir] || null;
    }
    if (next) { next.focus(); return true; }
    if (dir > 0) {
      var target = this.root.querySelector('.mz__qty, .mz__link, .mz__reset');
      if (target) { target.focus(); return true; }
    }
    return false;
  };

  Maatzoeker.prototype.onKey = function (k, e) {
    var ui = this.ui[k];
    var open = !ui.list.hidden;
    if ((e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) && this.isFreeText(k)) {
      e.preventDefault();
      this.freeText(k);
      return;
    }
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (!open) { this.open(k); return; }
        if (ui.shown.length) { ui.active = (ui.active + 1) % ui.shown.length; this.renderList(k); }
        return;
      case 'ArrowUp':
        e.preventDefault();
        if (open && ui.shown.length) { ui.active = (ui.active - 1 + ui.shown.length) % ui.shown.length; this.renderList(k); }
        return;
      case 'Enter':
        e.preventDefault();
        if (open && ui.shown.length && ui.active >= 0) {
          this.commit(k, ui.shown[ui.active].key);
          this.focusNext(k, 1);
        } else if (!open) {
          this.open(k);
        }
        return;
      case 'Tab':
        if (e.shiftKey) {
          // terug: getypte tekst die exact een optie is, wordt toch overgenomen
          if (ui.typing && open && ui.shown.length === 1) this.commit(k, ui.shown[0].key);
          this.close(k, true);
          e.preventDefault();
          if (!this.focusNext(k, -1)) {
            var tabBtn = this.root.querySelector('.mz__tab[aria-selected="true"]');
            if (tabBtn) tabBtn.focus();
          }
          return;
        }
        // vooruit: gemarkeerde suggestie overnemen als er iets getypt is (of als er maar één optie is)
        if (open && ui.shown.length && ui.active >= 0 && (ui.typing || ui.shown.length === 1)) {
          this.commit(k, ui.shown[ui.active].key);
        } else {
          this.close(k, true);
        }
        e.preventDefault();
        this.focusNext(k, 1);
        return;
      case 'Escape':
        if (open) { e.preventDefault(); this.close(k, true); ui.input.select(); }
        return;
      case 'Backspace':
        if (this.sel[k] != null && !ui.typing) {
          e.preventDefault();
          delete this.sel[k];
          ui.input.value = '';
          this.update(k);
          this.open(k);
        }
        return;
    }
  };

  Maatzoeker.prototype.renderResults = function () {
    var box = this.root.querySelector('.mz__results');
    var status = this.root.querySelector('.mz__status');
    var res = this.results();
    var nSel = Object.keys(this.sel).length;
    var groupName = (GROUPS.filter(function (g) { return g[0] === this.tab; }, this)[0] || ['', ''])[1];
    this.root.querySelector('.mz__reset').hidden = !nSel;

    if (!nSel && this.tab === 'alles') {
      status.innerHTML = '<strong>' + res.length + '</strong> inchmaten op voorraad. Kies hierboven, of typ en druk op <kbd>Tab</kbd>.';
      box.innerHTML = '';
      return;
    }
    if (!res.length) {
      status.innerHTML = '<strong>0</strong> artikelen met deze combinatie op voorraad.';
      box.innerHTML = '<div class="mz__empty"><strong>Staat uw maat er niet tussen?</strong> Wij tonen online alleen onze eigen voorraad, ' +
        'maar kunnen via onze leveranciers veel meer inchmaten leveren. <a href="' + esc(this.contactUrl) + '">Vraag het ons</a>' +
        (this.phone ? ' of bel <a href="tel:' + esc(this.phone.replace(/\s/g, '')) + '">' + esc(this.phone) + '</a>' : '') + '.</div>';
      return;
    }
    status.innerHTML = '<strong>' + res.length + '</strong> ' + (res.length === 1 ? 'artikel past' : 'artikelen passen') +
      (this.tab !== 'alles' ? ' in ' + esc(groupName.toLowerCase()) : '');
    var shown = this.showAll ? res : res.slice(0, this.limit);
    var html = '<ul class="mz__rows">' + shown.map(function (p) {
      return '<li class="mz__row">' +
        '<a class="mz__thumb" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' +
        (p.i ? '<img src="' + esc(p.i) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</a>' +
        '<div class="mz__info"><a class="mz__link" href="' + esc(p.u) + '">' + esc(p.t) + '</a>' +
        (p.x ? '<span class="mz__badge">Uitlopend · op = op</span>' : '') + '</div>' +
        '<div class="mz__price">' + EUR.format((p.p || 0) / 100) + '<small>per stuk</small></div>' +
        '<div class="mz__buy">' + (p.a && p.v ?
          '<label class="mz__vh" for="mz-q-' + p.v + '">Aantal</label><input class="mz__qty" id="mz-q-' + p.v + '" type="number" min="1" value="1" inputmode="numeric">' +
          '<button type="button" class="mz__add" data-v="' + p.v + '">In winkelwagen</button>' :
          '<span class="mz__sold">Uitverkocht</span>') + '</div>' +
        '</li>';
    }).join('') + '</ul>';
    if (!this.showAll && res.length > shown.length) {
      html += '<button type="button" class="mz__more">Toon alle ' + res.length + ' artikelen</button>';
    }
    box.innerHTML = html;
  };

  Maatzoeker.prototype.addToCart = function (btn) {
    var row = btn.closest('.mz__row');
    var qtyEl = row.querySelector('.mz__qty');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    btn.disabled = true;
    btn.textContent = 'Bezig…';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +btn.getAttribute('data-v'), quantity: qty }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        btn.textContent = '✓ Toegevoegd';
        btn.classList.add('is-done');
        var info = row.querySelector('.mz__info');
        if (!info.querySelector('.mz__tocart')) {
          info.insertAdjacentHTML('beforeend', '<a class="mz__tocart" href="' + root + 'cart">Naar winkelwagen →</a>');
        }
        var icon = document.querySelector('cart-icon');
        if (icon && typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count);
        setTimeout(function () { btn.disabled = false; btn.textContent = 'In winkelwagen'; btn.classList.remove('is-done'); }, 2500);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = 'In winkelwagen';
        alertBox(row, (err && (err.description || err.message)) || 'Toevoegen lukte niet, probeer het opnieuw.');
      });
  };
  function alertBox(row, msg) {
    var el = row.querySelector('.mz__err');
    if (!el) { el = document.createElement('p'); el.className = 'mz__err'; el.setAttribute('role', 'alert'); row.querySelector('.mz__info').appendChild(el); }
    el.textContent = msg;
  }

  /* ---------- keuzes in de URL (delen / terugknop) ---------- */
  Maatzoeker.prototype.writeHash = function () {
    if (!this.root.hasAttribute('data-hash')) return;
    var parts = [];
    if (this.tab !== 'alles') parts.push('tab:' + this.tab);
    for (var k in this.sel) parts.push(k + ':' + this.sel[k]);
    var h = parts.length ? '#maat=' + encodeURIComponent(parts.join(';')) : '';
    if (h !== (location.hash.indexOf('#maat=') === 0 ? location.hash : '')) {
      history.replaceState(null, '', location.pathname + location.search + (h || ''));
    }
  };
  Maatzoeker.prototype.readHash = function () {
    if (!this.root.hasAttribute('data-hash')) return;
    var m = location.hash.match(/^#maat=(.+)$/);
    if (!m) return;
    var self = this;
    decodeURIComponent(m[1]).split(';').forEach(function (pair) {
      var i = pair.indexOf(':');
      if (i < 1) return;
      var k = pair.slice(0, i), v = pair.slice(i + 1);
      if (k === 'tab' && GROUPS.some(function (g) { return g[0] === v; })) self.tab = v;
      else if (FIELDS.some(function (f) { return f.k === k; })) self.sel[k] = v;
    });
  };

  /* ---------- zoekopdracht omzetten naar keuzes ----------
     'unc 1/2 x 2 verzinkt' -> Draadsoort UNC, Diameter 1/2", Lengte 2", Uitvoering Verzinkt.
     Alleen woorden die precies op een bestaande optie passen worden overgenomen. */
  var TAB_WORDS = [
    [/oogbout|oogmoer|ring|nippel|plug|assortiment/, 'overig'],
    [/tapbout|voldraad/, 'tapbouten'],
    [/inbus|cilinderkop|verzonken/, 'inbusbouten'],
    [/stelschroef|stelbout|setscrew|grub/, 'stelschroeven'],
    [/moer|\bnut/, 'moeren'],
    [/draadstang|draadeind|tapeind|\bstang/, 'draadstangen'],
    [/zeskantbout|\bbout|\bbolt/, 'zeskantbouten']
  ];
  var DRAAD_ALIAS = { whitworth: 'BSW', bsw: 'BSW', gasdraad: 'BSP', bsp: 'BSP', metrisch: 'M', unc: 'UNC', unf: 'UNF', bsf: 'BSF' };
  Maatzoeker.prototype.applyQuery = function (q) {
    var self = this, lower = q.toLowerCase(), tab = null;
    for (var i = 0; i < TAB_WORDS.length && !tab; i++) if (TAB_WORDS[i][0].test(lower)) tab = TAB_WORDS[i][1];
    if (tab) {
      this.tab = tab;
      if (!this.products.some(function (p) { return self.inTab(p); })) this.tab = 'alles';
    }
    var clean = lower
      .replace(/[×*]/g, ' x ')
      .replace(/(\d)\s+(\d+\/\d+)/g, '$1.$2')            /* 1 1/2 -> 1.1/2 */
      .replace(/(\d)["”″]?\s*-\s*(\d+)\b/g, '$1 $2')       /* 1/2"-13 -> 1/2 13 */
      .replace(/(\d)\s*x\s*(\d)/g, '$1 x $2')              /* 1/2x2 -> 1/2 x 2 */
      .replace(/#\s*(\d+)/g, 'nr$1');
    var toks = clean.split(/\s+/).filter(Boolean), afterX = false, hit = 0;
    var ORDER = ['draad', 'dia', 'spoed', 'uitv', 'kwal', 'type', 'lengte'];
    function find(k, t) {
      var nt = norm(t);
      if (!nt) return null;
      if (k === 'draad' && DRAAD_ALIAS[nt]) nt = norm(DRAAD_ALIAS[nt]);
      if (k === 'type' && /^(zeskant)?bout(en)?$/.test(nt)) return null;   /* algemeen woord: alleen tabblad */
      var opts = self.options(k);
      if (k === 'type') {
        var fam = opts.filter(function (o) { return o.fam && (norm(o.base) === nt || norm(o.plural) === nt); })[0];
        if (fam) return fam;
      }
      var exact = opts.filter(function (o) {
        if (norm(o.key) === nt || norm(o.label) === nt) return true;
        var inner = String(o.label).match(/\(([^)]+)\)/);          /* Nr. 10 (3/16") */
        return k === 'dia' && inner && norm(inner[1]) === nt;
      });
      if (exact.length === 1) return exact[0];
      if (k === 'type' && nt.length >= 5) {
        var pre = opts.filter(function (o) { return norm(o.label).indexOf(nt) === 0; });
        if (pre.length === 1) return pre[0];
      }
      return null;
    }
    for (var j = 0; j < toks.length; j++) {
      var t = toks[j];
      if (t === 'x') { afterX = true; continue; }
      var order = afterX && /\d/.test(t) ? ['lengte'].concat(ORDER) : ORDER, done = false;
      /* eerst twee woorden samen proberen: 'grade 5', 'rvs a4', 'heavy hex' */
      if (toks[j + 1] && toks[j + 1] !== 'x') {
        for (var a = 0; a < order.length && !done; a++) {
          if (this.sel[order[a]] != null) continue;
          var o2 = find(order[a], t + ' ' + toks[j + 1]);
          if (o2) { this.sel[order[a]] = o2.key; done = true; hit++; j++; }
        }
      }
      for (var b = 0; b < order.length && !done; b++) {
        if (this.sel[order[b]] != null) continue;
        var o1 = find(order[b], t);
        if (o1) { this.sel[order[b]] = o1.key; done = true; hit++; }
      }
      if (done && order[0] === 'lengte') afterX = false;
    }
    this.prune();
    return hit;
  };

  function init() {
    document.querySelectorAll('[data-maatzoeker]:not([data-mz-ready])').forEach(function (el) {
      el.setAttribute('data-mz-ready', '');
      new Maatzoeker(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.EBMaatzoeker = { prepare: prepare, norm: norm };
})();
